import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'bluetooth', 'Bluetooth', [["path",{"d":"M7 8l10 8l-5 4l0 -16l5 4l-10 8","key":"svg-0"}]]);